// Shared mobile-first bits for the employee section.

export const STATUS_STYLES = {
    "ny": "bg-slate-100 text-slate-700 border-slate-200",
    "i gang": "bg-blue-50 text-blue-700 border-blue-200",
    "færdig": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "afsluttet": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "klar": "bg-emerald-50 text-emerald-700 border-emerald-200",
    "aktiv": "bg-blue-50 text-blue-700 border-blue-200",
};

export function StatusBadge({ status }) {
    const key = (status || "Ny").toLowerCase();
    const cls = STATUS_STYLES[key] || "bg-slate-100 text-slate-700 border-slate-200";
    return (
        <span className={`inline-flex items-center px-2.5 py-1 rounded-full border text-xs font-semibold ${cls}`} data-testid="job-status-badge">
            {status || "Ny"}
        </span>
    );
}

const PRIO_STYLES = {
    "høj": "bg-rose-50 text-rose-700 border-rose-200",
    "medium": "bg-amber-50 text-amber-700 border-amber-200",
    "lav": "bg-slate-100 text-slate-600 border-slate-200",
};

export function PriorityBadge({ priority }) {
    const key = (priority || "Medium").toLowerCase();
    const cls = PRIO_STYLES[key] || PRIO_STYLES["medium"];
    return (
        <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-medium ${cls}`}>
            {priority || "Medium"}
        </span>
    );
}
